import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NestedEllipsisModule } from 'ngx-nested-ellipsis';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { UtilModule } from '@scaliolabs/baza-web-utils';

import { FavoriteButtonModule } from '../favorite-btn';
import { ItemCardComponent } from './item-card.component';

@NgModule({
    declarations: [ItemCardComponent],
    exports: [ItemCardComponent],
    imports: [
        CommonModule,
        FavoriteButtonModule,
        NestedEllipsisModule,
        NzAlertModule,
        NzButtonModule,
        NzCardModule,
        NzGridModule,
        NzPopoverModule,
        NzProgressModule,
        RouterModule,
        UtilModule,
    ],
})
export class ItemCardModule {}
